module.exports = __webpack_public_path__ + "static/media/test.c9747c78.png";